import { useEffect, useState } from "react";
import axios from 'axios';
import { getPrevSessionLocation, setPrevSessionLocation } from './firebase.js';

export default function useLocation(open) {

    const [location, setLocation] = useState(null);
    const [locationLoading, setLocationLoading] = useState(false);
    const [locationError, setLocationError] = useState(null);

    async function getLocation() {
        try {
            let location = await getPrevSessionLocation();
            if (location) {
                console.log("Location found: ", location);
                setLocation(location);
                setLocationLoading(false);
                return;
            }
            console.log("Location not found, fetching...");
            const response = await axios.get('https://ipapi.co/json/');
            location = response.data;
            if (!location) {
                throw new Error('Invalid location');
            }
            await setPrevSessionLocation(location);
            setLocation(location);
            setLocationLoading(false);
        } catch (error) {
            console.error('Error fetching location: ', error);
            setLocationError(error);
        }
    };

    useEffect(() => {
        if (open) {
            if (locationLoading || location || locationError) {
                return;
            }
            console.log("Getting location");
            getLocation();
        }
    }, [open]);

    return [location, locationLoading, locationError, getLocation];
}

